import Component from '../abstracts/Component';

export default class RecaptchaComponent extends Component {

  get SELECTORS() {
    return {
      main: '.g-recaptcha',
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.reCaptchaWidgets = {'automatics': [], 'manuals': {}};
    this.bindWindow();
    this.renderReCaptchaWidgets();
    window.RecapchaComponent = this;
  }

  getResponseFromWidget(widgetName) {
    const reCaptchaSiteKey = document.body.dataset.sitekey;
    let token = '';
    // If there a site key procede with rendering phase
    if (reCaptchaSiteKey != null && reCaptchaSiteKey != '' && grecaptcha != undefined) {
      try {
        const widgetId = this.reCaptchaWidgets['manuals'][widgetName];
        if (widgetId != undefined){
          token = grecaptcha.getResponse(widgetId);
          if (token == undefined || token == null || token == '') {
            grecaptcha.execute(widgetId);
            return false;
          } else {
            try{
              // The user have already a response for this widget
              // track a success using the widgetName as id
              window.TealiumReCaptchaSuccess(widgetName)
            }catch(e){
              console.log('TealiumReCaptchaSuccess error');
            }
          }
        }
      }catch(e){
        return true;
      }
    }
    return true;
  }

  renderReCaptchaWidgets() {
    // Get site key
    const reCaptchaSiteKey = document.body.dataset.sitekey;
    // If there a site key procede with rendering phase
    if (reCaptchaSiteKey != null && reCaptchaSiteKey != '') {
      // Check that the main onload callback has been fired
      if (this.reCaptchaWidgets == undefined){
        try{
          console.log('ReCaptcha not initialized. Impossible to render the manual widgets.');
        } catch(err) {
          // Fail to log
        }
        return;

      }

      $(".g-invisible-recaptcha-manual").each( (i,e) => {
        this.renderManualReCaptchaWidget(reCaptchaSiteKey, e);
      });

      $(".g-invisible-recaptcha-auto").each( (i,e) => {
        this.renderAutomaticReCaptchaWidget(reCaptchaSiteKey, e);
      });

      $(document).trigger('reCaptcha:automaticWidgetsLoaded');

      $(document).trigger('reCaptcha:manualWidgetsLoaded');

    }
  }

  renderAutomaticReCaptchaWidget(reCaptchaSiteKey, widgetElement){
    let el = $(widgetElement);
    let elData = $(el).data();
    let disabled = $(el).attr('disabled');

    // Calling Tealium render tracker
    try {
      window.TealiumReCaptchaRender();
    }catch(e){
      console.log("TealiumReCaptchaRender error");
    }

    if(typeof window.TealiumReCaptchaRender == "function") window.TealiumReCaptchaRender();
    //console.log('Rendering "auto" reCaptcha on', el);
    const widgetId = grecaptcha.render($(el).get(0), {
      'sitekey' : reCaptchaSiteKey,
      'size' : elData['size'] != undefined ? elData['size'] :  'invisible',
      'badge': elData['badge'] != undefined ? elData['badge'] :  'bottomright',
      'callback' : function(token) {
        if(typeof window.TealiumReCaptchaSuccess == "function") window.TealiumReCaptchaSuccess();
        // This function takes care of 'auto-submit' after the user complete the challange successfully
        let closestForm = $(el).closest('form');
        try{
          // Calling Tealium success tracker
          // Using the form id for track the functionality
          window.TealiumReCaptchaSuccess(closestForm.attr('id'));
        }catch(e){
          console.log('TealiumReCaptchaSuccess error');
        }
        closestForm.find('.g-recaptcha-response').val(token);
        closestForm.submit();
      }
    });

    //this method sets 'disabled' attribute to buttons previously disabled. After render they were enabled again
    if (disabled == 'disabled')
      $(el).attr('disabled', true);

    this.reCaptchaWidgets['automatics'].push(widgetId);
  }

  renderManualReCaptchaWidget(reCaptchaSiteKey, widgetElement){
    let el = $(widgetElement);
    let elData = $(el).data();
    let widgetName = elData['reCaptchaWidgetName'];

    if (widgetName) {
      try {
        if (this.reCaptchaWidgets['manuals'][widgetName]){
          // Widget already exist, procede with reset
          grecaptcha.reset(this.reCaptchaWidgets['manuals'][widgetName]);
        } else {
          // Calling Tealium render tracker
          try {
            window.TealiumReCaptchaRender();
          }catch(e){
            console.log("TealiumReCaptchaRender error");
          }
          if(typeof window.TealiumReCaptchaRender == "function") window.TealiumReCaptchaRender();
          const widgetId = grecaptcha.render($(el).get(0), {
            "sitekey" : reCaptchaSiteKey,
            "size" : elData['size'] != undefined ? elData['size'] :  "invisible",
            "badge": elData['badge'] != undefined ? elData['badge'] :  "bottomright",
            "callback" : elData['callback'] != undefined ? elData['callback'] : null,
          });
          this.reCaptchaWidgets['manuals'][widgetName] = widgetId;
        }
      }catch(e){
        console.log("error in reCapcha");
      }
    } else {
      console.log('Missing data-widget-name for reCaptcha widget: ', el);
    }

  }

  renderManualReCaptchaWidgetByName(widgetName){
    // Get site key
    const reCaptchaSiteKey = document.body.dataset.sitekey;
    // If there a site key procede with rendering phase
    if (reCaptchaSiteKey != null && reCaptchaSiteKey != '') {
      // Check that the main onload callback has been fired
      if (this.reCaptchaWidgets == undefined){
        console.log('ReCaptcha not initialized. Impossible to render the manual widgets.');
        return;
      }

      $(".g-invisible-recaptcha-manual").filter('[data-re-captcha-widget-name="'+ widgetName +'"]').each( (i,e) => {
        this.renderManualReCaptchaWidget(reCaptchaSiteKey, e);
      });
    }
  }

  bindWindow() {
    window.contactUsBtnCallback = () => {
      $('[data-contactus-recaptcha]').trigger( 'click' );
      // After the ajax call reset the widget to avoid expired tokens if there are
      grecaptcha.reset(this.reCaptchaWidgets['manuals']['contactUsPage']);
    }
    window.checkoutBtnCallback = () => {
      $('[data-contactus-recaptcha]').trigger( 'click' );
      // After the ajax call reset the widget to avoid expired tokens if there are
      grecaptcha.reset(this.reCaptchaWidgets['manuals']['checkoutPage']);
    }
  }


}
